import {
  createContext,
  useContext,
  useEffect,
  useLayoutEffect,
  useState,
} from 'react';
import { useSelector } from 'react-redux';

const PusherContext = createContext({
  channels: {
    account: null,
    user: null,
  },
});

const PusherProvider = ({ children, pusher }) => {
  const account = useSelector((s) => s.settings.account);
  const user = useSelector((s) => s.user.user);
  const [channels, setChannels] = useState({
    account: null,
    user: null,
  });

  useEffect(() => {
    if (global.IS_SERVER) return null;
    if (!account.hash) return;
    const accountChannelName = `presence-${account.hash}`;
    const userChannelName = `presence-${account.hash}-${user.user_hash}`;
    const accountChannel = pusher.subscribe(accountChannelName);
    const userChannel = pusher.subscribe(userChannelName);
    accountChannel.bind_global((eventName, data) => {
      console.log('Account event:', eventName, data);
    });
    userChannel.bind_global((eventName, data) => {
      console.log('User event:', eventName, data);
    });
    setChannels({
      user: userChannel,
      account: accountChannel,
    });
    return () => {
      pusher.unsubscribe(accountChannelName);
      pusher.unsubscribe(userChannelName);
    };
  }, [account.hash]);

  return (
    <PusherContext.Provider value={{ pusher, channels }}>
      {children}
    </PusherContext.Provider>
  );
};

export const usePusher = () => {
  return useContext(PusherContext);
};

export default PusherProvider;
